// Code generated by codegen. DO NOT EDIT!
//
// Use 'yarn codegen' to regenerate this file based on schema and
// file defined operations.

import {
  useQuery,
  useInfiniteQuery,
  UseQueryOptions,
  UseInfiniteQueryOptions,
} from "@tanstack/react-query";

import * as Types from "../../../../../gql/types";

import { fetcher } from "lib/client/graphql";
export type DestinationSectionAssetsAssetQueryVariables = Types.Exact<{
  assetId: Types.Scalars["ID"]["input"];
  checkinDate: Types.Scalars["Date"]["input"];
  checkoutDate: Types.Scalars["Date"]["input"];
  voucherCode?: Types.InputMaybe<Types.Scalars["String"]["input"]>;
}>;

export type DestinationSectionAssetsAssetQuery = {
  __typename?: "Query";
  asset: {
    __typename?: "Asset";
    id: string;
    spaceCategories: Array<{
      __typename?: "SpaceCategory";
      id: string;
      availableRates: {
        __typename?: "AvailableRateConnection";
        nodes: Array<{
          __typename?: "AvailableRateV2";
          id: string;
          perNightPrice: { amount: number; currency: string };
          originalPerNightPrice: { amount: number; currency: string } | null;
          promoName: string | null;
          enabledByVoucherCode: boolean | null;
        }> | null;
      } | null;
    }> | null;
  } | null;
};

export type DestinationSectionAssetsAvailableRateFragment = {
  __typename?: "AvailableRateV2";
  perNightPrice: { amount: number; currency: string };
  originalPerNightPrice: { amount: number; currency: string } | null;
  promoName: string | null;
  enabledByVoucherCode: boolean | null;
};

export const DestinationSectionAssetsAvailableRateFragmentDoc = `
    fragment DestinationSectionAssetsAvailableRate on AvailableRateV2 {
  perNightPrice
  originalPerNightPrice
  promoName
  enabledByVoucherCode
}
    `;
export const DestinationSectionAssetsAssetDocument = `
    query DestinationSectionAssetsAsset($assetId: ID!, $checkinDate: Date!, $checkoutDate: Date!, $voucherCode: String) {
  asset(id: $assetId) {
    id
    spaceCategories {
      id
      availableRates(
        checkinDate: $checkinDate
        checkoutDate: $checkoutDate
        voucherCode: $voucherCode
      ) {
        nodes {
          id
          ...DestinationSectionAssetsAvailableRate
        }
      }
    }
  }
}
    ${DestinationSectionAssetsAvailableRateFragmentDoc}`;
export const useDestinationSectionAssetsAssetQuery = <
  TData = DestinationSectionAssetsAssetQuery,
  TError = unknown,
>(
  variables: DestinationSectionAssetsAssetQueryVariables,
  options?: UseQueryOptions<DestinationSectionAssetsAssetQuery, TError, TData>,
) =>
  useQuery<DestinationSectionAssetsAssetQuery, TError, TData>(
    ["DestinationSectionAssetsAsset", variables],
    fetcher<
      DestinationSectionAssetsAssetQuery,
      DestinationSectionAssetsAssetQueryVariables
    >(DestinationSectionAssetsAssetDocument, variables),
    options,
  );

useDestinationSectionAssetsAssetQuery.getKey = (
  variables: DestinationSectionAssetsAssetQueryVariables,
) => ["DestinationSectionAssetsAsset", variables];

export const useInfiniteDestinationSectionAssetsAssetQuery = <
  TData = DestinationSectionAssetsAssetQuery,
  TError = unknown,
>(
  pageParamKey: keyof DestinationSectionAssetsAssetQueryVariables,
  variables: DestinationSectionAssetsAssetQueryVariables,
  options?: UseInfiniteQueryOptions<
    DestinationSectionAssetsAssetQuery,
    TError,
    TData
  >,
) => {
  return useInfiniteQuery<DestinationSectionAssetsAssetQuery, TError, TData>(
    ["DestinationSectionAssetsAsset.infinite", variables],
    (metaData) =>
      fetcher<
        DestinationSectionAssetsAssetQuery,
        DestinationSectionAssetsAssetQueryVariables
      >(DestinationSectionAssetsAssetDocument, {
        ...variables,
        ...(metaData.pageParam ?? {}),
      })(),
    options,
  );
};

useInfiniteDestinationSectionAssetsAssetQuery.getKey = (
  variables: DestinationSectionAssetsAssetQueryVariables,
) => ["DestinationSectionAssetsAsset.infinite", variables];
